module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-paymentOptionsInfo"
  }, [_c('i', {
    staticClass: "fa fas fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-5"
  }, [_vm._v("Secure payments")]), _vm._v(" "), _c('div', {
    staticClass: "ptb-10"
  }, [_vm._v("We accept payments via credit card and PayPal.")]), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('img', {
    attrs: {
      "src": _vm.paymentsAssetUrl.paypal
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.paymentsAssetUrl.mastercard
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.paymentsAssetUrl.visa
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b285c20","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/molecules/PaymentsOptionsInfo.vue
// module id = 538
// module chunks = 2